import React, { useEffect, useState } from 'react';
// import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome';
import axios from '../../axios-google-calendar';

const CalendarBase = (props) => {
	const {
		calendarUrl,
		month,
		year
	} = props;

	const [selectedMonth, setSelectedMonth] = useState(month);
	const [selectedYear, setSelectedYear] = useState(year);
	const [singleEvents, setSingleEvents] = useState([]);
	const [multiDayEvents, setMultiDayEvents] = useState([]);
	const [monthDisplay, setMonthDisplay] = useState('');
	const [pageLoading, setPageLoading] = useState(true);

	if(selectedMonth == null ) {
		setSelectedMonth(new Date().getMonth());
	}

	if(selectedYear == null) {
		setSelectedYear(new Date().getFullYear());
	}

	let url = '/2q11cjg6jsc3l8r3s0jlgt3tg0@group.calendar.google.com/events';
	if(calendarUrl && calendarUrl.length > 0) {
		url = '/' + calendarUrl + '/events';
	}

	useEffect(() => {
		setPageLoading(true);
		const localeOptions = { year: 'numeric', month: 'long' };

		setMonthDisplay(new Intl.DateTimeFormat('en-US', localeOptions).format(new Date(selectedYear, selectedMonth)));
		// setMonthDisplay(new Date(selectedYear, selectedMonth).toLocaleString('en-US', localeOptions));

		let startDate = new Date(selectedYear, selectedMonth);
		let endDate = new Date(selectedYear, selectedMonth + 1);
		endDate.setTime(endDate.getTime() - 1000);

		const params = {
			key: 'AIzaSyCOBqQ6rm6_Os8CQD2mBxjasWnYuWFQXtI',
			timeMin: startDate.toISOString(),
			timeMax: endDate.toISOString(),
			singleEvents: true,
			orderBy: 'startTime'
		};

		axios.get(url, { params })
		.then(response => {
			let returnedEvents = [];
			let returnedMultiDayEvents = [];
			if(response.data && response.data.items) {
				for(let i = 0; i < response.data.items.length; i++) {
					let calendarEvent = response.data.items[i];

					let timeZoneOffset = null;

					let UTCStartDate = null;
					if(calendarEvent.start.dateTime) {
						UTCStartDate = new Date(calendarEvent.start.dateTime);
					} else if (calendarEvent.start.date) {
						UTCStartDate = new Date(calendarEvent.start.date);
						timeZoneOffset = UTCStartDate.getTimezoneOffset();
						timeZoneOffset = timeZoneOffset * 60 * 1000;
						UTCStartDate.setTime(UTCStartDate.getTime() + timeZoneOffset);
					} else {
						continue;
					}

					let UTCEndDate = null;
					if(calendarEvent.end.dateTime) {
						UTCEndDate = new Date(calendarEvent.end.dateTime);
					} else if (calendarEvent.start.date) {
						UTCEndDate = new Date(calendarEvent.end.date);
						timeZoneOffset = UTCEndDate.getTimezoneOffset();
						timeZoneOffset = timeZoneOffset * 60 * 1000;
						UTCEndDate.setTime(UTCEndDate.getTime() + timeZoneOffset - 1000);
					} else {
						continue;
					}

					if(UTCStartDate < startDate) {
						UTCStartDate = startDate;
					}

					if(UTCEndDate > endDate) {
						UTCEndDate = endDate;
					}

					if(UTCEndDate > UTCStartDate) {
						if(UTCEndDate.getDate() > UTCStartDate.getDate() || UTCEndDate.getMonth() > UTCStartDate.getMonth() || UTCEndDate.getFullYear() > UTCStartDate.getFullYear()) {
							let currentDay = new Date(UTCStartDate);
							while(currentDay < UTCEndDate) {
								let storedStartTime = new Date(currentDay);
								let storedEndTime = new Date(currentDay);
								storedEndTime.setTime(storedEndTime.getTime() + (24 * 60 * 60 * 1000));
								returnedMultiDayEvents.push({
									title: calendarEvent.summary,
									link: calendarEvent.htmlLink,
									startDate: storedStartTime,
									endDate: storedEndTime,
									firstDay: UTCStartDate,
									lastDay: UTCEndDate
								});
								currentDay.setTime(currentDay.getTime() + (24 * 60 * 60 * 1000));
							}
						} else {
							returnedEvents.push({
								title: calendarEvent.summary,
								link: calendarEvent.htmlLink,
								startDate: UTCStartDate,
								endDate: UTCEndDate
							});
						}
					}
				}
			}

			setMultiDayEvents(returnedMultiDayEvents);
			setSingleEvents(returnedEvents);
			setPageLoading(false);

		}).catch(error => {
			console.warn("Error", error);
		});

	}, [selectedMonth, selectedYear, calendarUrl, url]);

	const previousMonth = () => {
		if(selectedMonth === 0) {
			setSelectedMonth(11);
			setSelectedYear(selectedYear - 1);
		} else {
			setSelectedMonth(selectedMonth - 1);
		}
	}

	const nextMonth = () => {
		if(selectedMonth === 11) {
			setSelectedMonth(0);
			setSelectedYear(selectedYear + 1);
		} else {
			setSelectedMonth(selectedMonth + 1);
		}
	}

	let firstDay = (new Date(selectedYear, selectedMonth)).getDay();
	const daysInMonth = new Date(selectedYear, selectedMonth + 1, 0).getDate();
	let today = new Date();

	let currentRow = [];
	let calendarRows = [];

	const daysOfTheWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	const calendarHeader = [];
	daysOfTheWeek.forEach(function (name) {
		calendarHeader.push(<th>{name}</th>);
	});


	const matchingDate = (comparisonDate, currentMonth, currentYear) => {
		return function (calendarEvent) {
			return calendarEvent.startDate.getDate() === comparisonDate && currentYear === calendarEvent.startDate.getFullYear() && currentMonth === calendarEvent.startDate.getMonth()
		}
	};

	let date = 1;

	for (let i = 0; i < 6; i++) {
		for (let j = 0; j < 7; j++) {
			if (i === 0 && j < firstDay) {
				currentRow.push(<td>&nbsp;</td>)
			}
			else if (date > daysInMonth) {
				currentRow.push(<td>&nbsp;</td>)
			}
			else {

				const matchingEvents = singleEvents.filter(matchingDate(date, selectedMonth, selectedYear));

				const matchingMultiDayEvents = multiDayEvents.filter(matchingDate(date, selectedMonth, selectedYear));


				/*
				const matchingEvents = singleEvents.filter(function (singleEvent) {
					return singleEvent.startDate.getDate() === date && selectedYear === singleEvent.startDate.getFullYear() && selectedMonth === singleEvent.startDate.getMonth();
				});

				const matchingMultiDayEvents = multiDayEvents.filter(function (multiDayEvent) {
					return multiDayEvent.startDate.getDate() === date && selectedYear === multiDayEvent.startDate.getFullYear() && selectedMonth === multiDayEvent.startDate.getMonth();
				});
				*/

				let dailyEvents = [];
				let displayMultipleDays = [];

				if (matchingEvents && matchingEvents.length > 0) {
					for (let k = 0; k < matchingEvents.length; k++) {
						dailyEvents.push(<div className='calendarEvent'><span>{matchingEvents[k].title}</span></div>);
					}
				}

				if (matchingMultiDayEvents && matchingMultiDayEvents.length > 0) {
					for(let l = 0; l < matchingMultiDayEvents.length; l++) {
						let days = Math.floor((matchingMultiDayEvents[l].lastDay - matchingMultiDayEvents[l].firstDay) / (1000 * 60 * 60 * 24)) + 1;

						let width;
						let additionalPixels = 1;
						if (matchingMultiDayEvents[l].firstDay.getDate() === matchingMultiDayEvents[l].startDate.getDate()) {
							if (days >= (7 - j)) {
								switch (7 - j) {
									case 1:
									additionalPixels = 0;
									break;
									case 2:
									case 3:
									additionalPixels = 1;
									break;
									case 4:
									case 5:
									additionalPixels = 6;
									break;
									case 6:
									additionalPixels = 8;
									break;
									case 7:
									additionalPixels = 8;
									break;
									default:
									additionalPixels = 0;
									break;
								}
								width = 'calc(' + ((7 - j) * 100) + '% + ' + additionalPixels + 'px)';
							} else {
								switch (days) {
									case 1:
									case 2:
									case 3:
									additionalPixels = 1;
									break;
									case 4:
									case 5:
									additionalPixels = 2;
									break;
									case 6:
									case 7:
									additionalPixels = 3;
									break;
									default:
									additionalPixels = 0;
									break;
								}
								width = 'calc(' + (days * 100) + '% + ' + additionalPixels + 'px)';
							}

							displayMultipleDays.push(<div className='calendarEvent multiDayEvent' style={{ width: width }}><span>{matchingMultiDayEvents[l].title}</span></div>);
						} else if(j === 0) {
							let remainingDays = Math.floor((matchingMultiDayEvents[l].lastDay - matchingMultiDayEvents[l].startDate) / (1000 * 60 * 60 * 24)) + 1;
							switch (remainingDays) {
								case 1:
								case 2:
								additionalPixels = 1;
								break;
								case 3:
								additionalPixels = 2;
								break;
								case 4:
								additionalPixels = 3;
								break;
								case 5:
								case 6:
								additionalPixels = 5;
								break;
								default:
								additionalPixels = 10;
							}
							if(remainingDays >= 7) {
								width = 'calc(' + (7 * 100) + '% + ' + additionalPixels + 'px)';
							} else {
								width = 'calc(' + (remainingDays * 100) + '% + ' + additionalPixels + 'px)';
							}

							displayMultipleDays.push(<div className='calendarEvent multiDayEvent startOfWeek'  style={{ width: width }}><span>&nbsp;</span></div>);
						}
					}
				}

				let displayDate = (<span className='day'>{date.toString()}</span>);

				if(date === today.getDate() && selectedYear === today.getFullYear() && selectedMonth === today.getMonth()) {
					currentRow.push(<td className='today'>{displayDate}{displayMultipleDays}{dailyEvents}</td>)
				} else {
					currentRow.push(<td>{displayDate}{displayMultipleDays}{dailyEvents}</td>)
				}

				date++;
			}
		}

		calendarRows.push(<tr>{currentRow}</tr>);

		if (date > daysInMonth) {
			break;
		}

		currentRow = [];
	}

	return (
		<React.Fragment>
			<div className='calendarControls'>
				<button onClick={previousMonth} disabled={pageLoading}>{'\u{276E}'}</button>
				{monthDisplay}
				<button onClick={nextMonth} disabled={pageLoading}>{'\u{276F}'}</button>
			</div>
			<table className='calendarGrid'>
				<thead>
					<tr>{calendarHeader}</tr>
				</thead>
				<tbody>{calendarRows}</tbody>
			</table>
		</React.Fragment>
	);
}

export default CalendarBase;
